module.exports = __webpack_public_path__ + "img/Kalkofen.5aee2213.svg";